import { render } from "./quizzes.vue?vue&type=template&id=6ab7257c"
import script from "./quizzes.vue?vue&type=script&lang=js"
export * from "./quizzes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__